export function shareProperty(location, propertyId) {
  navigator.clipboard.writeText(
    `${window.location.origin}/swipe?location=${location}&start=${propertyId}`
  )
}
